export const SERVICE_ORDER_TYPES = [
  { value: "pulverizacao", label: "Pulverização" },
  { value: "plantio", label: "Plantio" },
  { value: "colheita", label: "Colheita" },
  { value: "preparo_solo", label: "Preparo de solo" },
  { value: "gradagem", label: "Gradagem" },
  { value: "fertilizacao", label: "Fertilização" },
  { value: "calagem", label: "Calagem" },
  { value: "irrigacao", label: "Irrigação" },
  { value: "transporte", label: "Transporte" },
  { value: "monitoramento", label: "Monitoramento" },
  {
    value: "monitoramento_perda_colheita",
    label: "Monitoramento de perda de colheita",
  },
  { value: "manutencao", label: "Manutenção" },
  { value: "beneficiamento", label: "Beneficiamento" },
  { value: "outros", label: "Outros" },
  { value: "ponto_interesse", label: "Ponto de interesse" },
];

/** Valores legados ainda presentes em ordens antigas; não aparecem no cadastro. */
const LEGACY_SERVICE_ORDER_TYPE_ALIASES = {
  aplicacao: "pulverizacao",
};

export function normalizeServiceOrderType(value) {
  if (!value) return "";
  return LEGACY_SERVICE_ORDER_TYPE_ALIASES[value] || value;
}

export function serviceOrderTypeLabel(value, t) {
  if (!value) return "";
  const normalized = normalizeServiceOrderType(value);
  const match = SERVICE_ORDER_TYPES.find((item) => item.value === normalized);
  if (match) {
    return t ? t(match.label) : match.label;
  }
  return value;
}

export function isSprayCalibrationServiceType(value) {
  const normalized = normalizeServiceOrderType(value);
  return normalized === "pulverizacao" || normalized === "fertilizacao";
}

/** Receita, produtos, calda e tanque — padrão de aplicação química (por enquanto só pulverização). */
export function showsSprayRecipeFields(value) {
  return normalizeServiceOrderType(value) === "pulverizacao";
}

/** Cultivar, população, espaçamento, adubo e inoculante. */
export function showsPlantingFields(value) {
  return normalizeServiceOrderType(value) === "plantio";
}

/** Nome do fertilizante e taxa-alvo kg/ha. */
export function showsFertilizationFields(value) {
  return normalizeServiceOrderType(value) === "fertilizacao";
}

/** Seleção de máquinas no formulário da ordem de serviço. */
export function showsMachineFields(value) {
  return value !== "monitoramento_perda_colheita";
}

/** Gravação de áudio opcional na ordem de serviço. */
export function showsAudioFields(value) {
  return Boolean(value);
}

/** Rumo de pista (pontos A/B) — não se aplica a monitoramento de perda de colheita. */
export function showsTrackHeadingFields(value) {
  return value !== "monitoramento_perda_colheita";
}

/** Ferramenta de PMS, margem tolerada e amostras de perda de colheita. */
export function showsHarvestLossFields(value) {
  return value === "monitoramento_perda_colheita";
}
